import { Vue, Component, Prop } from 'vue-property-decorator'
import ArrowSvg from '~/assets/svg/arrow-search.svg?inline'
import LinkItem from '~/types/LinkItem'

@Component
export default class NavBackLink extends Vue {
  @Prop({ type: Object, required: true })
  readonly link?: LinkItem

  render () {
    const location = this.link?.location || '/'
    const title = this.link?.title || 'Назад'

    return (
      <nuxt-link {...{
        class: 'nav-back-link',
        props: {
          to: location
        }
      }}>
        <div class="nav-back-link__icon">
          <ArrowSvg />
        </div>

        <div class="nav-back-link__label">
          { title }
        </div>
      </nuxt-link>
    )
  }
}
